import { WEB_MAP, WEB_PORTAL,EDOTCO_SITE,OPERATOR_SITE } from "../constants/AppPermissionModels";

//when Super Admin, Admin, User, Reporting is provided output the appropriate property
export const formatRolesFrontEndToBAckEnd = (role) => {
  const type = role.toLowerCase();
  if (type === "all") return null;
  if (type === "super admin") return "super_admin";
  if (type === "reporting manager") return "reporting";
  if (type === "admin") return "admin";
  if (type === "user") return "user";
  if (type === "all users") return "all_users";
  return type;
};

export const formatRolesBackEndToFrontEnd = (role) => {
  if (role === "super_admin") return "Super Admin";
  if (role === "admin") return "Admin";
  if (role === "reporting") return "Reporting Manager";
  if (role === "user") return "User";
  else return "All";
};

export const formatEligibleModels = (appAccess = {}) => {
  const allowedModels = Object.keys(appAccess).map(key => {
    if (key === 'web_portal_access' && appAccess[key] === true) return WEB_PORTAL;
    if (key === 'web_map_access' && appAccess[key] === true) return WEB_MAP;
    if (key === 'edotco_site_access' && appAccess[key] === true) return EDOTCO_SITE;
    if (key === 'operator_site_access' && appAccess[key] === true) return OPERATOR_SITE;
    else return '';
  })
  return allowedModels || [];
};